/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import * as selectorsPedido from '../../../store/pedido/reducer';
import { savePedido, updatePedido, findPedidoById } from '../../../store/pedido/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import moment from 'moment';
import {
  InputV2, DefaultSelectV2, DialogDefaultV2, ArquivoContainerV2, DatePickerV2, UsuarioSelectV2
} from '../../../components/v2';
import ProdutosContainer from './ProdutosContainer';

const entradaSchema = {
  data: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  local: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  produtos: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  tipoEntrada: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const saidaSchema = {
  data: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  local: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  usuario: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  produtos: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const validateSchema = values => {
  let erros = {};
  if (values.tipo === "ENTRADA") {
    let customSchema = { fornecedor: { presence: { allowEmpty: false, message: 'é obrigatório' } } };
    if (values.tipoEntrada === "COLABORADOR") {
      customSchema = { usuario: { presence: { allowEmpty: false, message: 'é obrigatório' } } };
    }
    erros = validate(values, { ...entradaSchema, ...customSchema });
  } else {
    erros = validate(values, saidaSchema);
  }

  return erros;
};

const Formulario = ({ savePedido, updatePedido, selectedPedido, open, id, onClose, findPedidoById, authData, isEntrada }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isEntradaLocal, setIsEntradaLocal] = useState(false);

  useEffect(() => {
    if (open) {
      setValues({
        data: moment().valueOf(),
        usuarioNome: authData.nome,
        dataInclusao: moment().format("DD/MM/YYYY HH:mm:ss"),
      });
    } else {
      setValues({});
    }
  }, [authData, open]);

  useEffect(() => {
    setIsEntradaLocal(isEntrada);
  }, [isEntrada]);

  useEffect(() => {
    if (id) findPedidoById(id);
  }, [id]);

  useEffect(() => {
    if (id && selectedPedido && id === selectedPedido.id) {
      setValues({
        ...selectedPedido,
        data: moment(selectedPedido.data).valueOf(),
      });
      setIsEntradaLocal(selectedPedido.tipo === "ENTRADA");
    } else {
      setValues({
        data: moment().valueOf(),
        usuarioNome: authData.nome
      });
      setIsEntradaLocal(isEntrada);
    }
  }, [id, selectedPedido, authData]);

  const onSave = () => {
    const dataToSave = {
      ...values,
      tipo: isEntradaLocal ? "ENTRADA" : "SAIDA",
    };

    let erros = validateSchema(dataToSave);
    setErrors(erros);
    if (!erros || Object.keys(erros).length === 0) {
      if (dataToSave.file) {
        dataToSave.arquivo = {
          nome: dataToSave.file.name.split('.')[0],
          extensao: dataToSave.file.name.split('.').pop(),
          status: 'NOT_SYNC'
        };
      }

      if (dataToSave.id) updatePedido(dataToSave, saveCallback);
      else savePedido(dataToSave, saveCallback);
    }
  };

  const saveCallback = success => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onCloseLocal = isSave => {
    setErrors({});
    setValues({});
    onClose(isSave);
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title={`Pedido de ${isEntradaLocal ? "Entrada" : "Saída"}`}
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 3 }}>
          <DatePickerV2
            label="Data do Pedido"
            onChange={data => setValues({
              ...values,
              data: data.valueOf()
            })}
            value={values.data}
            isRequired
            error={!!(errors && errors.data)}
          />
        </Grid>
        {!id && <Grid size={{ xs: 12, sm: 9 }} />}
        {id && (
          <>
            <Grid size={{ xs: 12, sm: 3 }}>
              <InputV2
                label="Criado Por"
                value={values.usuarioNome}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
              <InputV2
                label="Data Inclusão"
                value={values.data ? moment(values.data).format("DD/MM/YYYY") : ""}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }} />
          </>
        )}
        <Grid size={{ xs: 12, sm: 3 }}>
          <DefaultSelectV2
            error={!!(errors && errors.local)}
            isRequired
            label="Local"
            showEmpty
            options={[
              { id: 'Almoxarifado I  C17', nome: 'Almoxarifado I  C17 ' },
              { id: 'Almoxarifado II  C17', nome: 'Almoxarifado II  C17' },
              { id: 'Sala Drones', nome: 'Sala Drones' },
              { id: 'Sucata', nome: 'Sucata' },
            ]}
            onSelect={event => {
              setValues({
                ...values,
                local: event.target.value,
              });
            }}
            value={values.local}
          />
        </Grid>
        {isEntradaLocal && (
          <>
            <Grid size={{ xs: 12, sm: 3 }}>
              <DefaultSelectV2
                error={!!(errors && errors.tipoEntrada)}
                isRequired
                label="Tipo"
                showEmpty
                options={[
                  { id: 'COLABORADOR', nome: 'Colaborador' },
                  { id: 'FORNECEDOR', nome: 'Fornecedor' },
                ]}
                onSelect={event => {
                  setValues({
                    ...values,
                    tipoEntrada: event.target.value,
                  });
                }}
                value={values.tipoEntrada}
              />
            </Grid>
            {values.tipoEntrada === "FORNECEDOR" && (
              <Grid size={{ xs: 12, sm: 6 }}>
                <InputV2
                  label="Fornecedor"
                  name="fornecedor"
                  value={values.fornecedor}
                  onChange={event => {
                    setValues({
                      ...values,
                      fornecedor: event.target.value,
                    });
                  }}
                  error={!!(errors && errors.fornecedor)}
                />
              </Grid>
            )}
            {values.tipoEntrada === "COLABORADOR" && (
              <Grid size={{ xs: 12, sm: 6 }}>
                <UsuarioSelectV2
                  label="Colaborador"
                  onSelect={usuario => setValues({
                    ...values,
                    usuario
                  })}
                  ativo
                  value={values.usuario}
                  isRequired={!isEntradaLocal}
                  error={errors && errors.usuario}
                />
              </Grid>
            )}
          </>
        )}
        {!isEntradaLocal && (
          <Grid size={{ xs: 12, sm: 6 }}>
            <UsuarioSelectV2
              label="Colaborador"
              onSelect={usuario => setValues({
                ...values,
                usuario
              })}
              ativo
              value={values.usuario}
              isRequired={!isEntradaLocal}
              error={errors && errors.usuario}
            />
          </Grid>
        )}
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao}
            rows={3}
            multiline
          />
        </Grid>
        <ProdutosContainer
          produtos={values.produtos}
          onSave={produtos => setValues({ ...values, produtos })}
          isEntrada={isEntradaLocal}
          showError={errors && errors.produtos}
        />
        <ArquivoContainerV2
          arquivos={values.arquivos || []}
          onSave={arquivos => setValues({ ...values, arquivos })}
        />
      </Grid>
    </DialogDefaultV2>
  );
};

const mapStateToProps = state => ({
  selectedPedido: selectorsPedido.getSelectedPedido(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  savePedido,
  updatePedido,
  findPedidoById,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Formulario);
